import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useStyles } from './styles';
export const InputError = memo(({ error, isWarning }) => {
    const classes = useStyles();
    return (_jsx("div", { className: classes.root, "data-error": !!error, "data-warning-color": isWarning, id: "input-error", children: error || '\u00a0' }));
});
